import { FileText } from 'lucide-react';
import { documents } from '../../../data';

export interface FooterLinksProps {
    onAboutClick: () => void;
    onContactClick: () => void;
}

export function FooterLinks({ onAboutClick, onContactClick }: FooterLinksProps) {
    const handleDownload = (path: string) => {
        window.open(process.env.PUBLIC_URL + path, '_blank');
    };

    return (
        <div className="flex flex-col items-center gap-4 py-6">
            {/* Documents */}
            <div className="flex flex-wrap justify-center gap-3">
                {documents.map((doc) => (
                    <button
                        key={doc.id}
                        onClick={() => handleDownload(doc.path)}
                        className="flex items-center gap-2 px-4 py-2 text-text-color text-sm rounded-lg hover:bg-gray-200 transition-colors"
                    >
                        <FileText className="w-4 h-4" />
                        {doc.name}
                    </button>
                ))}
            </div>

            {/* Navigation Links */}
            <div className="flex flex-wrap justify-center gap-4">
                <button
                    onClick={onAboutClick}
                    className="text-text-color hover:text-main-color transition-colors text-sm font-medium"
                >
                    Despre noi
                </button>
                <button
                    onClick={onContactClick}
                    className="text-text-color hover:text-main-color transition-colors text-sm font-medium"
                >
                    Contact
                </button>
                <a
                    href="https://www.renomia.ro/informatii-utile#form-solidpixels-1"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-text-color hover:text-main-color transition-colors text-sm font-medium"
                >
                    Petitii
                </a>
            </div>
        </div>
    );
}
